import { request } from "@/request/request";
import axios from "axios";
import { parameterChange } from "@/utils/utils";

// const requests = axios.create({
//   baseURL: "http://localhost:3000/api",
//   timeout: 60000,
//   headers: {},
// });
// mork数据

export default {
  // record(data) {
  //   return requests({
  //     url: "/record",
  //     method: "get",
  //     data,
  //   });
  // },
  // 获取题目
  getAigcInfo(data) {
    return request({
      url: "/aigc-info/getAigcInfo",
      method: "get",
      data,
    });
  },
  // 获取开发笔记
  getDevelopmentNote(data) {
    return request({
      url: "/aigc-answer/getDevelopmentNote",
      method: "get",
      data,
    });
  },
  // 填写开发笔记
  updateDevelopmentNote(data) {
    return request({
      url: "/aigc-answer/updateDevelopmentNote",
      method: "post",
      data,
    });
  },
  // // 网络图片转base64
  // imageToBase64(data) {
  //   return request({
  //     url: "/file/imageToBase64?" + parameterChange(data),
  //     method: "get",
  //     data,
  //   });
  // },
  // 上传网络图片
  uploadWebImage(data) {
    return request({
      url: "/file/uploadWebImage",
      method: "post",
      data,
    });
  },
  // 上传本地图片
  uploadLocalImage(data) {
    return request({
      url: "/file/uploadLocalImage",
      method: "post",
      data,
    });
  },
  // 获取作品
  aigcGetAnswer(data) {
    return request({
      url: "/aigc-answer/getAnswer",
      method: "get",
      data,
    });
  },
  // 提交作品
  aigcSubmitAnswer(data) {
    return request({
      url: "/aigc-answer/submitAnswer",
      method: "post",
      data,
    });
  },

  // 获取作品
  getChats(data) {
    return request({
      url: "/aigc-info/getChats",
      method: "get",
      data,
    });
  },
  // 保存聊天
  saveChats(data) {
    return request({
      url: "/aigc-info/saveChats",
      method: "post",
      data,
    });
  },
  // 创建任务
  imageSynthesis(data) {
    return request({
      url: "/aigc-info/imageSynthesis",
      method: "post",
      data,
    });
  },
  // 根据任务ID查询结果
  getTasksResults(taskId, data = {}) {
    return request({
      url: `/aigc-info/tasks/${taskId}`,
      method: "get",
      data,
    });
  },
  // 更新次数
  updateSubmitTimes(data) {
    return request({
      url: "/aigc-answer/updateSubmitTimes",
      method: "post",
      data,
    });
  },
  // 开始比赛
  startPaper(data) {
    return request({
      url: "/aigc-info/startPaper",
      method: "post",
      data,
    });
  },
};

